import React, { useState } from 'react';

interface ToggleSwitchProps {
    label1: string; // Label for the "OFF" state
    label2: string; // Label for the "ON" state
    initialState?: boolean; // Optional prop to set initial state
    onToggle: (state: boolean) => void; // Callback function when toggled
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label1, label2, initialState = false, onToggle }) => {
    const [isOn, setIsOn] = useState<boolean>(initialState);

    const toggleSwitch = () => {
        setIsOn(prevState => !prevState);
        onToggle(!isOn);
    };

    // Styles
    const toggleSwitchStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        width: '100px',
        height: '15px',
        borderRadius: '5px',
        backgroundColor: '#ccc',
        position: 'relative',
        padding: '5px',
        transition: 'background-color 0.3s',
    };

    const switchCircleStyle: React.CSSProperties = {
        width: '50px',
        height: '22px',
        backgroundColor: 'white',
        borderRadius: '5px',
        position: 'absolute',
        left: isOn ? '58px' : '2px',
        transition: 'left 0.3s',
        textAlign: 'center'
    };

    const labelStyle: React.CSSProperties = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        color: 'white',
        transition: 'opacity 0.3s',
    };

    return (
        <div style={toggleSwitchStyle} onClick={toggleSwitch}>
            <div style={{ ...labelStyle, left: '8px', opacity: isOn ? 1 : 0 }} > {label1} </div>
            <div style={{ ...labelStyle, right: '8px', opacity: isOn ? 0 : 1 }} > {label2}</div>
            <div style={switchCircleStyle} >
                {isOn ? label2 : label1}
            </div>
        </div>
    );
};

export default ToggleSwitch;